<template>
	<div class="horizontal-buttons horizontal-center">
		<b-button type="is-primary" rounded @click="onOkClick" :disabled="!isOkButtonEnable" :loading="isOkButtonLoading">{{ okButtonTitle }}</b-button>
		<b-button type="is-info" rounded @click="onCancelClick">キャンセル</b-button>
	</div>
</template>

<script>

export default {
	name: 'HorizontalButtons',
	props: {
		okButtonTitle: {
			type: String,
			default: 'OK',
		},
		isOkButtonEnable: {
			type: Boolean,
			default: true,
		},
		isOkButtonLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
	},
	methods: {
		onOkClick: function() {
			this.$emit('ok-click');
		},
		onCancelClick: function() {
			this.$emit('cancel-click');
		},
	},
}
</script>

<style lang="scss">

</style>
